const config = {
  processing: 'FSC đang tư vấn',
  invalid: 'Không hợp lệ',
  pending: 'Chờ Banker xác nhận',
  submitted: 'Đã nộp HSYCBH',
  issued: 'Đã phát hành HĐ',
};

const useLeadStatus = () => {
  return {
    options: Object.keys(config).map((k) => ({ value: k, label: config[k] })),
    getLabel: (value) => config[value] || value,
  };
};

export default useLeadStatus;